import { authReady } from 'rp-navigation';

/**
 * @ngdoc service
 * @name CommonUtils.ugc
 */

export default function ($http, config) {
    'ngInject';

    const urlCheck = `${config.get('resultsPath')}/ugc/checkNotes`;
    const urlGet = `${config.get('resultsPath')}/ugc/quickNotesGet`;
    const urlPost = `${config.get('resultsPath')}/ugc/quickNotesForm`;

    this.checkNotes = () => $http.get(`${urlCheck}`);

    this.get = raceId => $http.get(`${urlGet}/${raceId}`);

    this.post = formData => $http.post(urlPost, formData);

    this.rpNavigationAuthReady = () => authReady;
}



// WEBPACK FOOTER //
// ./src/js/services/ugc.js